import { Box } from "@mui/material";
import ButtonAItem from "../../core/assets/command/n64Buttons/items/ButtonAItem";
import ButtonCDownItem from "../../core/assets/command/n64Buttons/items/ButtonCDownItem";
import ButtonCLeftItem from "../../core/assets/command/n64Buttons/items/ButtonCLeftItem";
import ButtonCRightItem from "../../core/assets/command/n64Buttons/items/ButtonCRightItem";
import ButtonCUpItem from "../../core/assets/command/n64Buttons/items/ButtonCUpItem";
import { isNil } from "lodash";
import OcarinaNoteBackground from "../../core/assets/rsl/ocaarinaNote.png"

interface ReworkOcarinaNoteTrackerProps {
    top?: number,
    left?: number,
    notes: Array<string>
    setNotes: (v: string) => void
    noteShuffle: boolean
}


const ReworkOcarinaNoteTracker = (props: ReworkOcarinaNoteTrackerProps) => {

    let { setNotes, notes } = props;
 
    if(!props.noteShuffle)
        return null;

    return <Box  sx={{backgroundImage: `url(${OcarinaNoteBackground})`}}
        position={isNil(props.top) || isNil(props.left) ? "relative" : "absolute"} 
        width={225} height={60} justifyContent={"center"}
        top={props.top} left={props.left} display={"flex"} flexDirection={"row"} onClick={(e) => {if(!props.noteShuffle) e.preventDefault()}} paddingTop={"5px"}>
        
            <ButtonCLeftItem additionalOnClick={() => setNotes("cleft")} isObtained={notes.some(x => x === "cleft")}/>
            <ButtonCUpItem additionalOnClick={() => setNotes("cup")} isObtained={notes.some(x => x === "cup")}/>
            <ButtonCRightItem additionalOnClick={() => setNotes("cright")} isObtained={notes.some(x => x === "cright")}/>
            <ButtonCDownItem additionalOnClick={() => setNotes("cdown")} isObtained={notes.some(x => x === "cdown")}/>
            <ButtonAItem additionalOnClick={() => setNotes("a")} isObtained={notes.some(x => x === "a")}/>
    </Box>
}

export default ReworkOcarinaNoteTracker;